import { z } from 'zod';
import { centsSchema, idParamSchema, idSchema, isoDateSchema, positiveCentsSchema, timestampSchema } from './common.js';
import { TRANSACTION_STATUSES } from './assignment.js';
// --- Ledger : filtres et écran Transactions (lot 9) --------------------------------------
export const ledgerQuerySchema = z.object({
    propertyId: idParamSchema.optional(),
    categoryId: idParamSchema.optional(),
    bankAccountId: idParamSchema.optional(),
    status: z.enum(TRANSACTION_STATUSES).optional(),
    dateFrom: isoDateSchema.optional(),
    dateTo: isoDateSchema.optional(),
    /** Sous-chaîne cherchée dans le libellé brut, insensible à la casse. */
    search: z.string().trim().min(1).max(200).optional(),
});
// --- Agrégations : jour / semaine / mois / année, par bien ou consolidé -------------------
export const AGGREGATION_BUCKETS = ['day', 'week', 'month', 'year'];
export const ledgerAggregationsQuerySchema = z.object({
    bucket: z.enum(AGGREGATION_BUCKETS).default('month'),
    propertyId: idParamSchema.optional(),
    dateFrom: isoDateSchema.optional(),
    dateTo: isoDateSchema.optional(),
});
export const aggregationPointSchema = z.object({
    /** Début de la période, `AAAA-MM-JJ` quel que soit le pas choisi. */
    bucketStart: isoDateSchema,
    incomeCents: centsSchema,
    expenseCents: centsSchema,
    netCents: z.number().int(),
});
export const aggregationResponseSchema = z.array(aggregationPointSchema);
// --- Bilan annuel : synthèse par bien, par catégorie --------------------------------------
export const categoryTotalSchema = z.object({
    categoryId: idSchema,
    code: z.string(),
    label: z.string(),
    direction: z.enum(['income', 'expense']),
    totalCents: centsSchema,
});
export const propertyAnnualSummarySchema = z.object({
    propertyId: idSchema,
    propertyName: z.string(),
    currency: z.string(),
    categories: z.array(categoryTotalSchema),
    incomeCents: centsSchema,
    expenseCents: centsSchema,
    netCents: z.number().int(),
});
export const annualSummaryResponseSchema = z.object({
    year: z.number().int(),
    properties: z.array(propertyAnnualSummarySchema),
    consolidated: z.object({
        incomeCents: centsSchema,
        expenseCents: centsSchema,
        netCents: z.number().int(),
    }),
});
// --- Patrimoine : valeur estimée − capital restant dû -------------------------------------
export const propertyValuationInputSchema = z.object({
    valuationDate: isoDateSchema,
    estimatedValueCents: positiveCentsSchema,
    notes: z.string().trim().min(1).max(2000).nullable().default(null),
});
export const propertyValuationSchema = propertyValuationInputSchema.extend({
    id: idSchema,
    propertyId: idSchema,
    createdAt: timestampSchema,
});
export const patrimoinePointSchema = z.object({
    date: isoDateSchema,
    valueCents: centsSchema,
    outstandingCents: centsSchema,
    netCents: z.number().int(),
});
export const propertyPatrimoineSchema = z.object({
    propertyId: idSchema,
    propertyName: z.string(),
    currency: z.string(),
    /** `null` : aucune estimation saisie pour ce bien. */
    current: patrimoinePointSchema.nullable(),
    history: z.array(patrimoinePointSchema),
});
export const consolidatedPatrimoineSchema = z.object({
    asOf: isoDateSchema,
    totalValueCents: centsSchema,
    totalOutstandingCents: centsSchema,
    netCents: z.number().int(),
    byProperty: z.array(z.object({
        propertyId: idSchema,
        propertyName: z.string(),
        currency: z.string(),
        valueCents: centsSchema.nullable(),
        outstandingCents: centsSchema,
        netCents: z.number().int().nullable(),
    })),
});
//# sourceMappingURL=ledger.js.map